import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as accessibilityNotificationsActions from './accessibility-notifications.actions';

export class AccessibilityNotificationComponent extends Component {
  constructor(props){
    super(props);

    this.state = {
        removeRequests: []
    }
  }
  componentDidMount() {
    this.handleMessageRemoval();
  }

  componentWillUpdate(nextProps, nextState) {
    this.handleMessageRemoval();
  }

  handleMessageRemoval() {
    const { removeRequests } = this.state;
    const { accessibilityNotifications, accessibilityNotificationsActions, displayTime } = this.props;
    const { notifications } = accessibilityNotifications || {};
    const { removeNotification } = accessibilityNotificationsActions;

    var recentRemoveRequests = [];

    notifications && notifications.forEach(notification => {
      const needsRemoved = !removeRequests.includes(notification);
      if(needsRemoved) {
        recentRemoveRequests.push(notification);
        setTimeout(() => {
          this.setState((prevState, props) => {
            const { removeRequests : oldRemoveRequests } = prevState;
            const index = oldRemoveRequests.findIndex(val => val.id === notification.id);
            var newRemoveRequests = [...oldRemoveRequests];
            if(index > -1)
              newRemoveRequests.splice(index, 1);
            return { removeRequests : newRemoveRequests};
          });
          removeNotification(notification.id);
        }, displayTime);
      }
    });

    if(recentRemoveRequests.length > 0) {
      this.setState((prevState, props) => {
        const { removeRequests : oldRemoveRequests } = prevState;
        var newRemoveRequests = [...oldRemoveRequests, ...recentRemoveRequests];
        return { removeRequests : newRemoveRequests};
      });
    }
  }

  mapNotification(notification) {
    return <span id="message" key={notification.id}>{notification.message}</span>;
  }

  render() {
    const { accessibilityNotifications } = this.props;
    const { notifications } = accessibilityNotifications || {};

    const politeNotifications = notifications &&
      notifications.filter(notification => notification.alertLevel === 'polite');
    const assertiveNotifications = notifications &&
      notifications.filter(notification => notification.alertLevel === 'assertive');
    const rudeNotifications = notifications &&
      notifications.filter(notification => notification.alertLevel === 'rude');

    return (
      <div className='skip'>
        <div aria-live="polite">
          { politeNotifications && politeNotifications.map(this.mapNotification)}
        </div>
        <div aria-live="assertive">
          { assertiveNotifications && assertiveNotifications.map(this.mapNotification)}
        </div>
        <div aria-live="rude">
          { rudeNotifications && rudeNotifications.map(this.mapNotification)}
        </div>
      </div>
    );
  }
}

AccessibilityNotificationComponent.defaultProps = {
  displayTime : 300,
};

AccessibilityNotificationComponent.propTypes = {
  accessibilityNotifications : PropTypes.any,
  accessibilityNotificationsActions : PropTypes.any,
  displayTime : PropTypes.number,
};

const mapStateToProps = ({ accessibilityNotifications }) => {
  return {
    accessibilityNotifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    accessibilityNotificationsActions: bindActionCreators(accessibilityNotificationsActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessibilityNotificationComponent);



// WEBPACK FOOTER //
// src/common/accessibility-notifications/accessibility-notifications.component.js